import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideToastConfig } from 'ng-primitives/toast';

import { TOAST_DURATION, TOAST_PORT } from '@core/ports';

import { ToastService } from './toast.service';

export function provideToast(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideToastConfig({
      placement: 'top-end',
      duration: TOAST_DURATION.short,
      offsetTop: 12,
      offsetBottom: 12,
      offsetLeft: 12,
      offsetRight: 12,
      dismissible: true,
      maxToasts: 3,
      zIndex: 9999999,
      sequential: true,
      swipeDirections: ['left', 'right'],
      ariaLive: 'polite',
      gap: 12,
    }),
    { provide: TOAST_PORT, useExisting: ToastService },
  ]);
}
